import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./RoutesPage')

export const RoutesPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/RoutesPage/index.js